const authStyle = {
    main: `auth-bg w-screen h-screen -mt-[60px] bg-[red] flex items-center justify-center`,
    authContainer: `bg-[#fff] w-full max-w-[350px] text-black p-5 rounded-xl mx-4`,
    h3: `font-bold text-2xl`,
    input: `outline-none w-full my-2 px-3 py-2 text-sm border-2 border-borderGrey rounded-full max-w-[300px] text-[#222]`,
}

export default authStyle